class OSProductDescription extends HTMLElement {
  connectedCallback() {
    this.osContent = this.querySelector('[data-os-description-content]');
    this.osToggle = this.querySelector('[data-os-description-toggle]');

    if (!this.osContent || !this.osToggle) return;

    this.osToggle.addEventListener('click', this.osHandleToggle);
    this.osMediaQuery = window.matchMedia('(min-width: 750px)');
    this.osMediaQuery.addEventListener('change', this.osHandleViewportChange);
    requestAnimationFrame(this.osUpdateAvailability);
  }

  disconnectedCallback() {
    this.osToggle?.removeEventListener('click', this.osHandleToggle);
    this.osMediaQuery?.removeEventListener('change', this.osHandleViewportChange);
  }

  osHandleToggle = () => {
    const osExpanded = !this.classList.contains('is-expanded');
    this.classList.toggle('is-expanded', osExpanded);
    this.osToggle.setAttribute('aria-expanded', String(osExpanded));
    this.osToggle.textContent = osExpanded
      ? this.osToggle.dataset.osReadLess
      : this.osToggle.dataset.osReadMore;
  };

  osHandleViewportChange = () => {
    this.classList.remove('is-expanded');
    this.osToggle.setAttribute('aria-expanded', 'false');
    this.osToggle.textContent = this.osToggle.dataset.osReadMore;
    requestAnimationFrame(this.osUpdateAvailability);
  };

  osUpdateAvailability = () => {
    const osEnabled = this.osMediaQuery.matches
      ? this.classList.contains('os-product-description--desktop')
      : this.classList.contains('os-product-description--mobile');

    this.osToggle.hidden = !osEnabled || this.osContent.scrollHeight <= this.osContent.clientHeight + 1;
  };
}

if (!customElements.get('os-product-description')) {
  customElements.define('os-product-description', OSProductDescription);
}
